export default "__VITE_ASSET__e12626ad__"